import { useState } from "react"
import { CurrentType } from "../../../enum/CurrentType"
import { ServiceStepsLayout } from "./ServiceStepsLayout"


export const AddService = () => {
    const [currentType, setCurrentType] = useState<CurrentType>(CurrentType.ADD)

    return (
        <ServiceStepsLayout
            currentType={currentType}
            setCurrentType={(value) => setCurrentType(value)}
            _primaryKey={0}
        />
    )
}